import { enumFacilitySortOption } from '@rematter/frontend-lib-api-client';

import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';

const useFacilitiesQuery = createQueryHook(
  'shared.selectFacility',
  () => ({
    facilities: {
      __args: {
        sorting: [enumFacilitySortOption.NameAsc],
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        facilityName: true,
      },
    },
  }),
  {
    select: (data) => data?.facilities.entries ?? [],
  },
);

export const SelectFacilityTouch = createEntityTouchSelect.remotelySearched(
  'SelectFacility',
  useFacilitiesQuery,
  {
    formatLabel: (entity) => entity.facilityName,
  },
);
